import { render, staticRenderFns } from "./SAASTree.vue?vue&type=template&id=613f98de&scoped=true"
import script from "./SAASTree.vue?vue&type=script&lang=js"
export * from "./SAASTree.vue?vue&type=script&lang=js"
import style0 from "./SAASTree.vue?vue&type=style&index=0&id=613f98de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613f98de",
  null
  
)

export default component.exports